import {translate} from "../../../../../helper/translate";

class RunsManager {
    runs = [
        {
            value: 20,
            name: translate('Short'),
        },
        {
            value: 30,
            name: translate('Medium'),
        },{
            value: 50,
            name: translate('Long'),
        },
    ];

    constructor() {
    }

    getByName(name) {
        return this.runs.find(runs => runs.name === name);
    }

    getByValue(value) {
        return this.runs.find(runs => runs.value === value);
    }
}

export default new RunsManager()
